export type TimeUnit = 'days' | 'weeks' | 'months' | 'years';

export function convertToYears(value: string, unit: TimeUnit): number {
  const numValue = parseFloat(value);
  if (isNaN(numValue)) return 0;

  switch (unit) {
    case 'days':
      return numValue / 365.25;
    case 'weeks':
      return numValue / 52.1775;
    case 'months':
      return numValue / 12;
    case 'years':
      return numValue;
    default:
      return 0;
  }
}

export function convertHeight(value: number, fromUnit: 'cm' | 'in', toUnit: 'cm' | 'in'): number {
  if (fromUnit === toUnit) return value;
  return fromUnit === 'cm' ? value / 2.54 : value * 2.54;
}

export function convertWeight(value: number, fromUnit: 'kg' | 'lb', toUnit: 'kg' | 'lb'): number {
  if (fromUnit === toUnit) return value;
  return fromUnit === 'kg' ? value * 2.20462 : value / 2.20462;
}

export function parseAgeInput(input: string): { value: string; unit: TimeUnit } {
  const trimmedInput = input.trim().toLowerCase();
  const match = trimmedInput.match(/^(\d+(?:\.\d+)?)\s*(years?|months?|weeks?|days?)$/);
  
  if (match) {
    const [, value, unit] = match;
    let timeUnit: TimeUnit = 'years';
    
    if (unit.startsWith('day')) timeUnit = 'days';
    else if (unit.startsWith('week')) timeUnit = 'weeks';
    else if (unit.startsWith('month')) timeUnit = 'months';
    else if (unit.startsWith('year')) timeUnit = 'years';
    
    return { value, unit: timeUnit };
  }
  
  // Smart default for numbers without units in pediatric context
  const numValue = parseFloat(trimmedInput);
  if (!isNaN(numValue)) {
    // For pediatric calculator, assume months for values > 14 (common pediatric range)
    // and years for values <= 14
    if (numValue > 14) {
      return { value: trimmedInput, unit: 'months' };
    }
  }
  
  return { value: input, unit: 'years' };
} 